import { ReservationCreateForm, ReservationData, ReservationUpdateForm } from '../frontend-cms';

export const enum ReservationEvent {
    Add = 'reservation_add',
    Update = 'reservation_update',
    Remove = 'reservation_remove',
    Sync = 'reservation_sync',
    AddDraft = 'reservation_addDraft',
    ChangeDraftDuration = 'reservation_ChangeDraftDuration',
    RemoveDraft = 'reservation_RemoveDraft',
}

export interface AddEventData extends ReservationUpdateForm {
    id: string;
    scheduleIds: string[];
}

export interface UpdateEventData extends ReservationUpdateForm {
    id: string;
    scheduleIds: string[];
}

export interface AddDraftEventData extends ReservationCreateForm {
    scheduleIds: string[];
}

export interface ChangeDraftDurationEventData {
    draftId: string;
    scheduleIds: string[];
    startTime: string;
    duration: number;
}

export interface RemoveDraftEventData {
    scheduleIds: string[];
    draftId: string;
}

export interface RemoveEventData {
    id: string;
}

export interface SyncEventData {
    reservation: ReservationData;
}
